import { Injectable } from '@angular/core';

import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  
  constructor(
    private api: ApiService,
    private util: UtilService
  ) {}

  get jwt(): string | null {
    return localStorage.getItem('JwtToken');
  }
  get orgID(): string | null{
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  getAllCourseTopics(data: any) {
    const postData: APIRequest = {

      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };

    return this.api.post(URL.CONTENT.GET_ALL_COURSE_TOPICS, postData );
  }

  addOrEditCourseTopic(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };
    
    return this.api.post(URL.CONTENT.CREATE_UPDATE_COURSE_TOPIC, postData );
  }

  getAllCourseModules(data: any) {
    const postData: APIRequest = {

      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };

    return this.api.post(URL.CONTENT.GET_ALL_COURSE_MODULES, postData );
  }

  getAllCourseLevel2Details(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };
    
    return this.api.post(URL.CONTENT.GET_ALL_COURSE_LEVEL2_LIST, postData );
  }

  getAllCourses(data: any) {
    const postData: APIRequest = {

      requestBody: {
        ...data,
        orgId: data.orgid !== undefined ? data.orgid : parseInt(this.orgID, 10)
      }
    };

    return this.api.post(URL.CONTENT.GET_ALL_COURSES, postData );
  }

  saveCourseLevel2Details(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };
    
    return this.api.post(URL.CONTENT.INSERT_UPDATE_COURSE_LEVEL2_LIST, postData );
  }
  updateCourseVersionStatus(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.UPDATE_COURSE_VERSION_STATUS, postData );
  }

  updateCourseModuleStatus(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.UPDATE_COURSE_MODULE_STATUS, postData );
  }

  updateCourseTopicStatus(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.UPDATE_COURSE_TOPIC_STATUS, postData );
  }

  updateStatusLevel3(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.UPDATE_COURSE_LEVEL3_STATUS, postData );
  }

  deleteCourseVersionById(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.DELETE_COURSE_VERSION_BY_ID, postData );
  }
  deleteCourseLevel1ById(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.DELETE_COURSE_LEVEL1_BY_ID, postData );
  }
  deleteCourseLevel3ById(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.DELETE_COURSE_LEVEL3_BY_ID, postData );
  }
  
  deleteCourseLevel2ById(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.DELETE_COURSE_LEVEL2_BY_ID, postData );
  }
  updateCourseStatus(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.UPDATE_COURSE_STATUS, postData );
  }

  getAllCourseVersions(data: any) {
    const postData: APIRequest = {

      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };

    return this.api.post(URL.CONTENT.GET_ALL_COURSE_VERSIONS, postData );
  }
  getDetailsCourseVersion(data : any)
  {
    const postData: APIRequest = {
       
      requestBody: {
        orgId: parseInt(this.orgID, 10),
        
      }
    };
  }

  downloadCourse(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };
    
    return this.api.post(URL.CONTENT.DOWNLOAD_COURSE, postData );
  }

  getUrlMetaData(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.CONTENT.URL_META_DATA, postData );
  }
  
  getModuleHeadingName(id: any) {
    let heading: any;
    switch(parseInt(id, 10)) {
      case 1:
        heading = 'NOS';
        break;
      case 2:
        heading = 'Module';
        break;
      case 3:
        heading = 'Chapter';
        break;
      case 4:
        heading = 'Chapter';
        break;
      case 5:
        heading = 'Module';
        break;
      default:
        heading = 'Module';
    }
    return heading;
  }
  
  getCourseHeadingName(id: any) {
    let heading: any;
    switch(parseInt(id, 10)) {
      case 1:
        heading = 'QP';
        break;
      case 2:
        heading = 'Course';
        break;
      case 3:
        heading = 'Subject';
        break;
      case 4:
        heading = 'Subject';
        break;
      case 5:
        heading = 'Course';
        break;
      case 6:
        heading = 'Function';
        break;
      default:
        heading = 'Course';
    }
    return heading;
  }


}